export const PUBLIC_ROOT = "__public/"

export const isPublicKey = key => typeof key === "string" && key.startsWith(PUBLIC_ROOT)

export const isPublicFlag = value => String(value) === "true"

export const toPublicKey = key => (isPublicKey(key) ? key : PUBLIC_ROOT + key)

export const effectiveIsPublic = (prefix, isPublic) => isPublicKey(prefix) || isPublicFlag(isPublic)

export const uploadTarget = (prefix, isPublic) => (effectiveIsPublic(prefix, isPublic) ? toPublicKey(prefix) : prefix)

export const canPasteInto = prefix => !isPublicKey(prefix)

export const anonymousFileUrl = (base, key, tenantId) =>
	`${base}/${encodeURIComponent(key)}?tenantIdIfNoToken=${encodeURIComponent(tenantId)}`

export function planUploadLanding(prefix, files) {
	const stay = { landing: prefix, notice: null }
	const hasPublic = files.some(file => effectiveIsPublic(prefix, file.isPublic))
	if (!hasPublic || isPublicKey(prefix)) return stay

	const publicDestination = toPublicKey(prefix)
	const hasPrivate = files.some(file => !effectiveIsPublic(prefix, file.isPublic))
	if (hasPrivate) {
		return {
			landing: prefix,
			notice: {
				key: "core.uploadedToPublicAndPrivate",
				params: { publicDestination, privateDestination: prefix || "/" },
			},
		}
	}
	return {
		landing: publicDestination,
		notice: { key: "core.uploadedToPublicFolder", params: { destination: publicDestination } },
	}
}

export const planFileMove = ({ key, newKey, isPublic }) => {
	const move = { op: "move", key, newKey }
	return isPublicFlag(isPublic) && !isPublicKey(newKey) ? [move, { op: "publishCopy", key: newKey }] : [move]
}

export const planFileUpdate = ({ key, newKey, wasPublic, willBePublic }) => {
	if (isPublicKey(key)) return []
	const was = isPublicFlag(wasPublic)
	const will = isPublicFlag(willBePublic)
	const renamed = newKey !== key
	const move = renamed ? [{ op: "move", key, newKey }] : []
	const current = renamed ? newKey : key

	if (!was && will) return [...move, { op: "publishCopy", key: current }, { op: "setAcl", key: current, isPublic: true }]
	if (was && !will) return [{ op: "removePublicCopy", key }, ...move, { op: "setAcl", key: current, isPublic: false }]
	if (was && will && renamed) return [...move, { op: "publishCopy", key: current }]
	return move
}

export const planFileDelete = ({ key, isPublic }) => {
	const remove = { op: "deleteFile", key }
	return isPublicFlag(isPublic) && !isPublicKey(key) ? [{ op: "removePublicCopy", key }, remove] : [remove]
}

export const planEditorImage = ({ key, isPublic }) => {
	if (isPublicKey(key)) return { action: "insert", key }
	if (isPublicFlag(isPublic)) return { action: "copyThenInsert", sourceKey: key, key: toPublicKey(key) }
	return { action: "block" }
}
